import * as React from 'react';
import * as ReactDOM from 'react-dom';
import './theme';
import './index.pcss';
import {VendorApp} from "./vendor/VendorApp";

const init = function() {
  ReactDOM.render(<VendorApp />, document.getElementById('body'));
};

init();

